import React from 'react'

import { PersonAvatar } from '@sketch/components'
import { AddShareMemberNotificationFragment } from '@sketch/gql-types'

import { AvatarWrapper, RoleBadge } from './AddShareMemberPreview.styles'
import {
  Card,
  Separator,
  Thumbnail,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface AddShareMemberPreviewProps {
  notification: AddShareMemberNotificationFragment
}

export const AddShareMemberPreview = ({
  notification,
}: AddShareMemberPreviewProps) => {
  const { share, user, workspace } = notification

  if (!share || !user) return null

  const name = user.name ?? 'Someone'
  const avatarSrc = user.avatar?.small

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AvatarWrapper>
            {avatarSrc ? (
              <PersonAvatar
                flavour="image"
                size="96px"
                name={name}
                src={avatarSrc}
              />
            ) : (
              <PersonAvatar flavour="color" size="96px" name={name} />
            )}
          </AvatarWrapper>
          <TileTitle>{name}</TileTitle>
          <RoleBadge>Guest</RoleBadge>
        </Tile>

        <Separator />

        <Tile>
          <Thumbnail aria-hidden />
          <TileTitle>{share.name}</TileTitle>
          {share.project?.name && <TileMeta>{share.project.name}</TileMeta>}
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>
    </Card>
  )
}
